import api from './api';
import { Client, SearchClientData, SearchClientParams, SearchClientResponse } from './typings';

export const mapClientFields = (client: any) => ({
  userId: client.user_id,
  fullName: client.user_fullname,
  email: client.user.email,
  credit: client.credit,
  clientId: client.id,
  canPurchase: client.can_open_fridge,
  orders: client.orders ?? [],
  hasPendingTransations: client.has_pending_transactions,
});

export const fetchClients = async (search: string) => {
  const response = await api({
    url: `/api/client/?page=1&search=${search}`,
  });
  return response.data.results.map((client: any) => mapClientFields(client));
};

export async function fetchClient(id: number | string): Promise<any> {
  const response = await api<Client>({
    url: `/api/client/v2/${id}/`,
  });
  return response.data;
}
export async function fetchActualClient(): Promise<any> {
  const response = await api<Client>({
    url: '/api/user',
  });
  return response.data;
}
export async function searchClients(params: SearchClientParams): Promise<SearchClientData[]> {
  const response = await api<SearchClientResponse>({
    url: '/api/account/client/search/',
    params: { search_by: params.searchBy, search_criteria: params.searchCriteria, ps: 10 },
    signal: params.signal,
  });
  return response.data.results;
}
